/* Settings: Design, Backend und Tastenkürzel. */
import { useState } from 'react';
import I18n from '../i18n.ts';
import { Dialog, DialogBody, DialogFoot } from './dialog.tsx';
import { useT } from './hooks.ts';
import { DesignTab } from './DesignTab.tsx';
import { KeysTab } from './KeysTab.tsx';
import { BackendTab } from './BackendTab.tsx';
import type { BackendActions } from './BackendTab.tsx';
import type { BackendSession } from '../net/session.ts';

export type SettingsTabId = 'design' | 'backend' | 'keys';

export interface SettingsHost {
  /** Zuletzt gewählte Seite merken */
  rememberTab(tab: SettingsTabId): void;
}

export function SettingsDialog(props: { host: SettingsHost; session: BackendSession; actions: BackendActions; initialTab?: SettingsTabId; onClose: () => void }) {
  const t = useT();
  const [tab, setTab] = useState<SettingsTabId>(props.initialTab || 'design');
  const choose = (id: SettingsTabId) => { setTab(id); props.host.rememberTab(id); };
  const [foot, setFoot] = useState<HTMLElement | null>(null);
  const tabs: [SettingsTabId, string][] = [['design', t('settings.tab_design')], ['backend', t('settings.tab_backend')], ['keys', t('settings.tab_keys')]];

  return (
    <Dialog title={t('app.settings')} onClose={props.onClose}>
      <div className="vlv-tabs" role="tablist">
        {tabs.map(([id, label]) => <button key={id} role="tab" aria-selected={tab === id} onClick={() => choose(id)}>{label}</button>)}
      </div>
      {tab === 'design' && <DesignTab />}
      {tab === 'backend' && <BackendTab session={props.session} actions={props.actions} />}
      {tab === 'keys' && <KeysTab key={I18n.lang} foot={foot} />}
      <DialogFoot>
        <span ref={setFoot} style={{ display: 'contents' }} />
        <button className="btn primary" onClick={props.onClose}>{t('settings.done')}</button>
      </DialogFoot>
    </Dialog>
  );
}
